import cn from "classnames";
import React from "react";

import { IProps } from "./index.d";
import {
  MobileOnly,
  TabletOnly,
  DesktopOnly,
  XLargeOnly,
  XXLargeOnly,
  TabletAndAbove,
  TabletAndBelow,
  DesktopAndAbove,
  XLargeAndAbove,
} from "./Viewport.css";

/**
 * This component can be used to conditionally display content based on the viewport.
 *
 * If used with the "noJS" prop, if used as a React Server Component (RSC),
 * or during SSR, it will render all possible viewports,
 * hiding ones that do not apply using media queries.
 *
 * It is not valid to pass noJS={false} if rendered from a React Server Component (RSC).
 */
export const ResponsiveContentV2: React.FC<IProps> = (props) => {
  const {
    mobile,
    tablet,
    desktop,
    xlarge,
    xxlarge,
    tabletAndAbove,
    tabletAndBelow,
    desktopAndAbove,
    xLargeAndAbove,
    noJS,
    flat,
  } = props;

  if (noJS === false) {
    throw new Error(
      "ResponsiveContentV2 is being used as a React Server Component, but noJS was set to false."
    );
  }

  const wrap = (content: React.ReactNode, className: string) => {
    if (flat) {
      return React.Children.map(content, (child) => {
        return React.cloneElement(child as React.ReactElement, {
          className: cn(
            className,
            (child as React.ReactElement).props.className
          ),
        });
      });
    } else {
      return <span className={className}>{content}</span>;
    }
  };

  return (
    <>
      {mobile ? wrap(mobile, MobileOnly) : null}
      {tablet ? wrap(tablet, TabletOnly) : null}
      {desktop ? wrap(desktop, DesktopOnly) : null}
      {xlarge ? wrap(xlarge, XLargeOnly) : null}
      {xxlarge ? wrap(xxlarge, XXLargeOnly) : null}
      {tabletAndAbove ? wrap(tabletAndAbove, TabletAndAbove) : null}
      {tabletAndBelow ? wrap(tabletAndBelow, TabletAndBelow) : null}
      {desktopAndAbove ? wrap(desktopAndAbove, DesktopAndAbove) : null}
      {xLargeAndAbove ? wrap(xLargeAndAbove, XLargeAndAbove) : null}
    </>
  );
};
